import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export const Login: React.FC = () => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const success = await login(userId, password);
    if (success) {
      navigate('/dashboard');
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-1220">
      <div className="max-w-md w-full space-y-8" data-id="element-1221">
        <div data-id="element-1222">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-1223">
            Tazama Connection Studio
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1224">
            Sign in to your account
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-1225">
          <div className="rounded-md shadow-sm -space-y-px" data-id="element-1226">
            <div data-id="element-1227">
              <label htmlFor="user-id" className="sr-only" data-id="element-1228">
                User ID
              </label>
              <input id="user-id" name="userId" type="text" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="User ID" value={userId} onChange={e => setUserId(e.target.value)} data-id="element-1229" />
            </div>
            <div data-id="element-1230">
              <label htmlFor="password" className="sr-only" data-id="element-1231">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} data-id="element-1232" />
            </div>
          </div>
          {error && <div className="text-red-500 text-sm text-center" data-id="element-1233">{error}</div>}
          <div data-id="element-1234">
            <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1235">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>;
};